import { createContext, useCallback, useContext, useState } from "react";
import DatasheetDialog from "./DatasheetDialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "hgw-datasheet-lead";
const Ctx = createContext(null);

const readLead = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const postLead = (lead, sheet, lang) =>
  fetch(`${API}/datasheet-leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({ ...lead, product_slug: sheet.slug, product_name: sheet.name, datasheet_url: sheet.url, lang }),
  });

export function DatasheetProvider({ children }) {
  const [lead, setLead] = useState(readLead);
  const [sheet, setSheet] = useState(null);

  const saveLead = useCallback((l) => {
    localStorage.setItem(KEY, JSON.stringify(l));
    setLead(l);
  }, []);

  return (
    <Ctx.Provider value={{ lead, saveLead, openGate: setSheet }}>
      {children}
      <DatasheetDialog sheet={sheet} onClose={() => setSheet(null)} />
    </Ctx.Provider>
  );
}

export const useDatasheet = () => useContext(Ctx);
